export const GROUP_TYPE = {
  DEFAULT: 1,
  COMPANY: 2,
  HOLDING: 3,
};

export const GROUP_ACTIVE_STATUS = {
  INACTIVE: 1,
  ACTIVE: 2,
};

export const GROUP_USERS_STATUS = {
  WITH_USERS: 1,
  WITHOUT_USERS: 2,
};

export const GROUP_COMMUNITIES_STATUS = {
  WITH_COMMUNITIES: 1,
  WITHOUT_COMMUNITIES: 2,
};

export const GROUP_TYPE_LABEL = {
  [GROUP_TYPE.DEFAULT]: 'Default',
  [GROUP_TYPE.COMPANY]: 'Company',
  [GROUP_TYPE.HOLDING]: 'Owner',
};

export const GROUP_ACTIVE_STATUS_LABEL = {
  [GROUP_ACTIVE_STATUS.INACTIVE]: 'Inactive',
  [GROUP_ACTIVE_STATUS.ACTIVE]: 'Active',
};

export const GROUP_USERS_STATUS_LABEL = {
  [GROUP_USERS_STATUS.WITHOUT_USERS]: 'No Users',
  [GROUP_USERS_STATUS.WITH_USERS]: 'Has Users',
};

export const GROUP_COMMUNITIES_STATUS_LABEL = {
  [GROUP_COMMUNITIES_STATUS.WITH_COMMUNITIES]: 'Has Communities',
  [GROUP_COMMUNITIES_STATUS.WITHOUT_COMMUNITIES]: 'No Communities',
};
